import { render, staticRenderFns } from "./MatchPlayer.vue?vue&type=template&id=f8927982&scoped=true"
import script from "./MatchPlayer.vue?vue&type=script&lang=js"
export * from "./MatchPlayer.vue?vue&type=script&lang=js"
import style0 from "./MatchPlayer.vue?vue&type=style&index=0&id=f8927982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8927982",
  null
  
)

export default component.exports